<template>
  <div class="landing-page">
    <div class="landing-title">
      {{
        $t('text.welcome_to_patient_management', {
          patient: $firstLetterCapitalize($store.state.locale.patient)
        })
      }}
    </div>
    <div>
      <div class="section-card">
        <div class="section-card-title">
          <img class="title-icon w-10" src="@/assets/image/info.png" />
          <span>{{ $t('text.useful_features') }}</span>
        </div>
        <div class="feature-container">
          <el-carousel
            :interval="7000"
            arrow="always"
            height="470px"
            :class="features.length === 1 ? 'signle-feature' : ''"
          >
            <el-carousel-item
              v-for="feature in features"
              :key="feature.title + feature.order"
            >
              <div class="feature-item">
                <div class="feature-animation">
                  <img :src="feature.animation" />
                </div>
                <div class="feature-content">
                  <div class="feature-title">{{ feature.title }}</div>
                  <div class="feature-desc" v-html="feature.desc"></div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div
        class="section-card"
        v-if="p('Patients.Add') || p('Patients.Edit')"
        id="quick-actions"
      >
        <div class="section-card-title">
          <img class="title-icon" src="@/assets/image/quick-action-icon.png" />
          <span>{{ $t('text.quick_actions') }}</span>
        </div>
        <div
          v-for="action in quickActions"
          :key="action.title"
          class="quick-operate-item"
          @click="action.onClickAction(action.title, action.actionType)"
          v-show="p(action.permission)"
        >
          <div class="left-icon-wrapper v-h-center">
            <img
              :src="
                require('@/assets/image/quick-operation-icon/' + action.icon)
              "
              :style="{ width: action.iconWidth + 'px' }"
            />
          </div>
          <div class="right-content">
            <div class="quick-operate-title">{{ action.title }}</div>
            <div class="quick-operate-desc">{{ action.desc }}</div>
          </div>
        </div>
      </div>
    </div>
    <EditPatient ref="editPatient" />
    <UpdatePatientDeviceAndProucts ref="updatePatientDeviceAndProucts" />
    <UpdatePatient ref="updatePatient" />
    <RemoveOrArchivePatient ref="removeOrArchivePatient" />
    <ScrollButton :lessHeightWillShow="800" />
  </div>
</template>

<script>
import EditPatient from '@/components/manage/patients/EditPatient.vue'
import UpdatePatientDeviceAndProucts from '@/components/patients/quickActions/UpdatePatientDeviceAndProucts.vue'
import UpdatePatient from '@/components/patients/quickActions/UpdatePatient.vue'
import RemoveOrArchivePatient from '@/components/manage/patients/RemoveOrArchivePatient.vue'
import ScrollButton from '@/components/ScrollButton.vue'
import { patientQuickActions } from '@/const'
export default {
  data() {
    return {
      features: [
        {
          order: 0,
          title: this.$t('text.patient_landing_slide2_title', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc: this.$t('text.patient_landing_slide2_content', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          animation: require('@/assets/image/useful-features/patient-landing/patient-landing-patient-centered-care.svg')
        },
        {
          order: 1,
          title: this.$t('text.patient_landing_slide3_title'),
          desc: this.$t('text.patient_landing_slide3_content', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          animation: require('@/assets/image/useful-features/patient-landing/patient-management-slide 2.gif')
        },
        {
          order: 2,
          title: this.$t('text.patient_landing_slide1_title'),
          desc: this.$t('text.patient_landing_slide1_content', {
            pad: this.$store.state.locale.pad,
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          animation: require('@/assets/image/useful-features/patient-landing/patient-landing-intro.svg')
        },
        {
          order: 3,
          title: this.$t('text.patient_landing_slide4_title', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc: this.$t('text.patient_landing_slide4_content', {
            patients: this.$firstLetterCapitalize(
              this.$store.state.locale.patients
            ),
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          animation: require('@/assets/image/useful-features/patient-landing/patient-landing-dashboard.svg')
        },
        {
          order: 4,
          title: this.$t('text.patient_landing_slide5_title'),
          desc: this.$t('text.patient_landing_slide5_content', {
            pad: this.$firstLetterCapitalize(this.$store.state.locale.pad),
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          animation: require('@/assets/image/useful-features/patient-landing/patient-landing-chart.svg')
        },
        {
          order: 5,
          title: this.$t('text.patient_landing_slide6_title'),
          desc: this.$t('text.patient_landing_slide6_content', {
            pad: this.$firstLetterCapitalize(this.$store.state.locale.pad),
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          animation: require('@/assets/image/useful-features/patient-landing/patient-landing-goal.svg')
        }
      ],
      quickActions: [
        {
          title: this.$t('text.add_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.add_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.addPatient,
          icon: 'add-patient.png',
          iconWidth: 36,
          actionType: patientQuickActions.addPatient,
          permission: 'Patients.Add'
        },
        {
          title: this.$t('text.update_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.update_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatient,
          icon: 'update-patient.png',
          iconWidth: 38,
          actionType: patientQuickActions.updatePatient,
          permission: 'Patients.Edit'
        },
        {
          title: this.$t('text.change_patient_products', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.change_patient_products_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'change-product.png',
          iconWidth: 36,
          actionType: patientQuickActions.changeProduct,
          permission: 'Patients.Edit'
        },
        {
          title: this.$t('text.reassign_pod_to_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.reassign_pod_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'reassign-pod.png',
          iconWidth: 36,
          actionType: patientQuickActions.assignPod,
          permission: 'Patients.Edit'
        },
        {
          title: this.$t('text.monitor_patient_with_a_node', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.monitor_patient_with_a_node_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.updatePatientDeviceAndProucts,
          icon: 'assign-node.png',
          iconWidth: 36,
          actionType: patientQuickActions.assignNode,
          permission: 'Patients.Edit'
        },
        {
          title: this.$t('text.remove_or_archive_patient', {
            patient: this.$firstLetterCapitalize(
              this.$store.state.locale.patient
            )
          }),
          desc:
            this.$t('text.remove_or_archive_patient_quick_action_desc', {
              patient: this.$store.state.locale.patient
            }) + '.',
          onClickAction: this.removeOrArchivePatient,
          icon: 'remove-or-archive-patient.png',
          iconWidth: 34,
          actionType: null,
          permission: 'Patients.Delete'
        }
      ]
    }
  },
  components: {
    EditPatient,
    UpdatePatientDeviceAndProucts,
    UpdatePatient,
    RemoveOrArchivePatient,
    ScrollButton
  },
  methods: {
    addPatient() {
      this.$refs.editPatient.openDialog()
    },
    updatePatient() {
      this.$refs.updatePatient.openDialog()
    },
    updatePatientDeviceAndProucts(title, actionType) {
      this.$forceUpdate()
      this.$refs.updatePatientDeviceAndProucts.openDialog(title, actionType)
    },
    removeOrArchivePatient() {
      this.$refs.removeOrArchivePatient.openDialog()
    }
  }
}
</script>
